import { useEffect, useMemo, useState } from 'react'
import { Form, FormSpy } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { SelectFormField } from '../../../../common/components/Form/SelectFormField/SelectFormField'
import { SelectElement, SelectOption } from '../../../../common/components/Select/Select'
import { GameFilters } from '../../../../contexts/OwnGamesContextProvider'
import { useDebounce } from '../../../../hooks/useDebounce'
import { Tag } from '../../../../types/commonTypes'
import styles from './ManageTagsFilter.module.css'

const tagPrefixEl: SelectElement = {
  type: 'icon',
  icon: { name: 'tag' },
}

type ManageTagsFiltersProps = {
  onChange: (tag: Tag | null) => void
  allTags: Tag[]
}

export const ManageTagsFiltersForm: React.FC<ManageTagsFiltersProps> = ({ onChange, allTags }) => {
  const { t } = useTranslation()

  const [filters, setFilters] = useState<Tag | null>(null)
  const debouncedFilters = useDebounce(filters, 1_000)

  useEffect(() => {
    onChange(debouncedFilters)
  }, [onChange, debouncedFilters])

  const tagOptions = useMemo<Array<SelectOption<number>>>(() => {
    return allTags.map((tag) => ({ value: tag.id, label: tag.label })) ?? []
  }, [allTags])

  const handleFilterChange = (value: number) => {
    const selectedTag = allTags.find((tag) => tag.id === value)
    setFilters(selectedTag ? selectedTag : null)
  }

  return (
    <Form<GameFilters> onSubmit={() => onChange(filters)}>
      {({ values, handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.filtersContainer}>
          <SelectFormField<number>
            name='tag'
            options={tagOptions}
            label={t('settings_organization.players.tags.manage.filter.label', 'Tag')}
            placeholder={t('settings_organization.players.tags.manage.filter.label', 'Tag')}
            srOnlyLabel
            prefixElement={tagPrefixEl}
            isClearable
            isSearchable
            fieldContainerClassName={styles.passedContainer}
            //labelClassName
            //className
          />
          <FormSpy onChange={(props) => handleFilterChange(props.values.tag as unknown as number)} />
        </form>
      )}
    </Form>
  )
}
